import { createClient } from "@supabase/supabase-js";
import { requirePortalConfig } from "../config.js";

let client;

export function getSupabase() {
  if (!client) {
    const config = requirePortalConfig();
    client = createClient(config.supabaseUrl, config.supabasePublishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}
